module.exports = __webpack_public_path__ + "img/AC.3700bbe3.jpg";